import React from "react";
import { Button, Box } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import GenericMUITable from "../../../components/GenericTable";
import { useNavigate } from "react-router-dom";

const SocietiesTable = ({ data, pagination }) => {
  console.log(pagination, data, "my pagination component");
  const navigate = useNavigate();
  const roleFields = [
    { key: "orgName", label: "Organization Name" },
    { key: "name", label: "Owner Name" },
    { key: "email", label: "Email" },
    { key: "mobileNo", label: "Mobile No" },
    { key: "referralId", label: "Referral Id" },
    { key: "programManagerName", label: "Program Manager Name" },
    { key: "programManagerCode", label: "Program Manager Code" },
    {
      key: "status",
      label: "Status",
      render: (item) => (item?.status ? item.status.toUpperCase() : ""),
    },
    {
      key: "actions",
      label: "Actions",
      render: (society) => {
        return (
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Button
              size="small"
              onClick={() => navigate(`/society-partner-hub/${society.orgName}`, { state: { society } })}
              aria-label={`Manage permissions for ${society.name}`}
              sx={{ minWidth: "auto", p: "4px" }}
            >
              <VisibilityIcon sx={{ color: "#828282" }} />
            </Button>
          </Box>
        );
      },
    },
  ];
  return <GenericMUITable fields={roleFields} data={data} rowKey="id" pagination={pagination} />;
};

export default SocietiesTable;
